import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';

import {SigninOverlayMessageContainer} from "./containers/SigninOverlayMessageContainer.js";
import {
	buildPageFromType,
	buildRedirectURL,
	onSubmitEmail,
	isGivingCartPopup,
	isContactPage,
	isRedirectURLFromCreateGivingPage,
	getGivingPageCampaignFromRedirectURL,
	onSendInstantSignin, onSendPasswordReset,
} from './utilities/signinUtilities.js';

export const SigninOverlayEmail = createReactClass({
	propTypes: {
		username: PropTypes.string,
		first: PropTypes.string,
		showLoadingDots: PropTypes.func.isRequired,
		toggleSigninOverlay: PropTypes.func.isRequired
	},

	onFormSubmit() {
		dcAnalytics.track("Sign in - email screen - submit");
		this.props.showLoadingDots();
		onSubmitEmail(event);
	},

	onDismissClick(event) {
		event.preventDefault();
		this.props.toggleSigninOverlay();
	},

	onSendInstantSigninClick: function(event) {
		dcAnalytics.track("Sign in - email screen - magic link");
		this.props.showLoadingDots();
		onSendInstantSignin(event);
	},

	onSendForgotPasswordClick: function(event) {
		dcAnalytics.track("Sign in - email screen - forgot password");
		this.props.showLoadingDots();
		onSendPasswordReset(event);
	},

	renderFirstTimer() {
		if (isRedirectURLFromCreateGivingPage()) {
			return(
					<div>
						<h2 className="overlay-separator">First-timer?</h2>
						<div className="first-timer">
							<span>If you're here to create a giving page,</span>
							<a target="_parent" href={secureBaseURL + 'donors/create.html?new=true&path=givingpage&campaign='+getGivingPageCampaignFromRedirectURL()+'&Iamnewteacher=false'}>create an account.</a>

							<span className="new-teacher">If you're a teacher in need of funding,</span>
							<a target="_parent" href={secureBaseURL + 'teacher/teacher_registration.html'}>create a teacher account.</a>
						</div>
					</div>
			);
		}

		if (isGivingCartPopup()) {
			return(
				<div className="skip-sign-in">
					Don't want to sign in? You can also <a href="#" onClick={this.onDismissClick}>check out without signing in</a> but you won't have access to your saved payment info. We'll still attribute the donation to your account.
				</div>
			);
		}

		if (isContactPage()) {
			return(
				<div className="button-block">
					<div>
						<a target="_parent" id="forgot-link" onClick={this.onSendForgotPasswordClick}
						   href={secureBaseURL + 'donors/forgot_password.html'}>
							Forgot your password?
						</a>
					</div>
					<h4>OR</h4>
					<div>
						<a target="_parent" id="magic-link" onClick={this.onSendInstantSigninClick}
						   href={secureBaseURL + 'common/instant_signin_email.html'}>
							Send instant sign in link via email
						</a>
					</div>
				</div>
			);
		}

		return (
			<div>
				<h2 className="overlay-separator">First-timer?</h2>
				<div className="first-timer">
					<span>If you're here to donate there's no need to sign up,</span>
					<a target="_parent" href={baseURL + 'donors/search.html'}>just find a classroom project to fund</a>!

					<span className="new-teacher">If you're a teacher in need of funding,</span>
					<a target="_parent" href={secureBaseURL + 'teacher/teacher_registration.html'}>create an account</a>.
				</div>
			</div>
		);

	},

	renderSubHeader () {
		if (isGivingCartPopup()) {
			return (
				<p className={'subheader'}>
					Sign in to retrieve your account info.
				</p>
			);
		}
		return null;
	},

	renderWelcomeBack() {
		if (this.props.first) {
			var first = decodeURIComponent(this.props.first);
			return(
					<h2>Welcome back, {first}!</h2>
			);
		}
		return(
			<h2>Welcome back!</h2>
		);
	},

	render() {

		var signinClass = "overlay-padding";
		if (isGivingCartPopup()) {
			signinClass = signinClass + " cart-sign-in";
		}

		return (
				<div id="signin-overlay" className={signinClass}>

					<iframe name="signin-overlay-submit-iframe" id="signin-overlay-submit-iframe" height="0" width="0"
							frameBorder="0" scrolling="no"></iframe>

					<div className="signin-content" id="signin-messages">
						<SigninOverlayMessageContainer />
					</div>

					<div className="signin-content" id="signin-main">
						<form className="form-redux"
							  id="signin-overlay-form"
							  method="post"
							  action={secureBaseURL + 'common/signin_json.html'}
							  onSubmit={this.onFormSubmit}
							  target="signin-overlay-submit-iframe">
							<input type="hidden" name="action" value="window.signinOverlay2Part.signinOverlayCallback" />
							<input type="hidden" name="go" value={buildRedirectURL()} />
							<input type="hidden" name="pageFromType" value={buildPageFromType()} />

							{this.renderWelcomeBack()}
							{this.renderSubHeader()}

							<div className="input-holder">
								<label htmlFor="signin-email">Email address</label>
								<input id="signin-email" name="username" type="email" defaultValue={this.props.username} autoFocus/>
							</div>
							<div className="button-block">
								<input type="submit" className="button-primary trigger" id="signin-overlay-submit-button" value="Continue to sign in" />
							</div>
						</form>

						{this.renderFirstTimer()}

					</div>

				</div>
		);
	}
});
